import PubSub from "underpub-js";
import gsap from 'gsap';

var ContentInfoDropdowns = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-ContentInfoDropdowns',
	};

	$.extend(true, this.options, options);

};

ContentInfoDropdowns.prototype.init = function() {

	var self = this;

	this.$dropdownHeadings = this.options.$el.find(`.${self.options.baseClass}__infoDropdown__headingText`);
	this.openItem = null;

	this.$dropdownHeadings.on('click', function() {

		console.log($(this));
		console.log(self.openItem);

		var $thisDropdown = $(this).closest(`.${self.options.baseClass}__infoDropdown`);

		if ($thisDropdown.hasClass('open')) {
			self.closeDropdown($thisDropdown);
			self.openItem = null;
		}
		else {
			self.openDropdown($thisDropdown);
		}

	});

};

ContentInfoDropdowns.prototype.openDropdown = function($infoDropdown) {

	var self = this;

	var $infoTextWrapper = $infoDropdown.find(`.${self.options.baseClass}__infoDropdown__infoTextWrapper`);
	var $infoHeadingIndicator = $infoDropdown.find(`.${self.options.baseClass}__infoDropdown__headingText__indicator .${self.options.baseClass}__line`).get(0);

	$infoDropdown.addClass('open');

	if ($infoDropdown != self.openItem) {

		// self.closeDropdown(this.openItem);

		this.openItem = $infoDropdown;

		gsap.timeline(
			{
				defaults: {
					ease: "power1.out",
					duration: 0.45
				}
			}
		)
		.to($infoTextWrapper,
			{
				height: "auto"
			}
		)
		.to($infoHeadingIndicator,
			{
				rotate: 0
			},
			"<"
		)
		;

	}

};

ContentInfoDropdowns.prototype.closeDropdown = function($infoDropdown) {

	var self = this;
console.log('close dropdown');
	if (!$infoDropdown) { return; }

	var $infoTextWrapper = $infoDropdown.find(`.${self.options.baseClass}__infoDropdown__infoTextWrapper`);
	var $infoHeadingIndicator = $infoDropdown.find(`.${self.options.baseClass}__infoDropdown__headingText__indicator .${self.options.baseClass}__line`).get(0);

	$infoDropdown.removeClass('open');

	gsap.timeline(
		{
			defaults: {
				ease: "power1.out",
				duration: 0.45
			}
		}
	)
	.to($infoTextWrapper,
		{
			height: 0
		}
	)
	.to($infoHeadingIndicator,
		{
			rotate: 90
		},
		"<"
	)
	;

};

export default ContentInfoDropdowns;
